import { useMemo, type ReactElement } from 'react';
import { usePageBreadcrumb, usePageSidebar, useStrapiApi, useStrapiParams } from '@/hooks';
import { sidebarItems } from './sidebar';
import { useParams } from 'react-router-dom';
import type { ProductCatalog, StrapiListRequest, StrapiResponse } from '@/interfaces/strapi';
import { getProductBySlug } from '@/services/strapi';
import { ROUTES } from '@/constants';
import { CatalogProductDetail } from '@/components';

export const Producto = (): ReactElement => {
	const { category: categorySlug, product: productSlug } = useParams<{ category: string; product: string }>();
	const params = useStrapiParams({
		page: 1,
		pageSize: 1,
		additionalFilters: productSlug ? { slug: { $eq: productSlug } } : {},
		populate: {
			image: true,
			categoria: true,
		},
	});

	const { data: productResponse, loading: loadingProduct } = useStrapiApi<
		StrapiResponse<ProductCatalog>,
		StrapiListRequest
	>(getProductBySlug, {
		autoFetch: true,
		params,
	});

	const product = productResponse?.data;

	usePageBreadcrumb([
		{ label: 'Academia Matritense', to: ROUTES.ACADEMIA_MATRITENSE_HISTORIA },
		{ label: 'Catálogo', to: ROUTES.ACADEMIA_MATRITENSE_CATALOGO },
		{ label: product?.name ?? '' },
	]);

	// Sidebar estable (memoizado)
	const sidebar = useMemo(() => sidebarItems, []);
	usePageSidebar(sidebar, true);

	return <div>{loadingProduct ? <p>Cargando…</p> : product && <CatalogProductDetail product={product} />}</div>;
};
